import { post } from 'utils/api';

export const login = async (data) => {
  return post('/auth/login', data);
};

export const forgotPassword = (data) => {
  return post(`/auth/forgot-password`, data);
};

export const resetPassword = (data) => {
  return post(`/auth/reset-password?token=${data.token}`, { password: data.password });
};

export const authApi = {
  login,
  forgotPassword,
  resetPassword,
};
